import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchSmsReloads, deleteSmsReload } from "actions/company";
import {
  toggleFullPageSpinner,
  toggleNotification,
  toggleconfirmationPopup
} from "actions/toggle";

import Table from "./Table";
import ReloadBUtton from "./ReloadButton";
import Pagination from "components/Pagination";

class SmsReloadIndex extends Component {
  componentDidMount() {
    const { companyId } = this.props.match.params;
    this.props.fetchSmsReloads(companyId, { partials: "user" });
  }

  onPaginationClick = page => event => {
    const { companyId } = this.props.match.params;
    this.props.fetchSmsReloads(companyId, { page });
  };

  handleCompanyDelete = id => event => {
    const {
      toggleconfirmationPopup,
      deleteSmsReload,
      fetchSmsReloads,
      match: {
        params: { companyId }
      }
    } = this.props;
    toggleconfirmationPopup(true, {
      onClickDelete: () => {
        deleteSmsReload(companyId, id)
          .then(() => {
            fetchSmsReloads();
            toggleNotification(true, {
              infoClassName: "is-success",
              message: "Delete SMS Reload Success"
            });
            toggleconfirmationPopup(false, {});
          })
          .catch(({ message }) => {
            toggleNotification(true, { infoClassName: "is-danger", message });
            toggleconfirmationPopup(false, {});
          });
      },
      title: "Delete SMS Reload",
      body: "Are you sure you want to delete this sms reload?"
    });
  };

  render() {
    const { companyId } = this.props.match.params;
    const { smsReloads } = this.props;

    return (
      <div>
        <div className="box">
          <ReloadBUtton companyId={companyId} />
          <Table
            smsReloads={smsReloads}
            companyId={companyId}
            onClickDelete={this.handleCompanyDelete}
          />
          <Pagination
            onClick={this.onPaginationClick}
            currentPage={smsReloads.current_page}
            lastPage={smsReloads.last_page}
            range="4"
            modifyClasses="is-right"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ companies, smsReloads }) => ({
  companies,
  smsReloads
});

export default connect(mapStateToProps, {
  fetchSmsReloads,
  toggleFullPageSpinner,
  toggleconfirmationPopup,
  toggleNotification,
  deleteSmsReload
})(SmsReloadIndex);



// WEBPACK FOOTER //
// ./src/pages/Company/SmsReload/index.js